import React from "react";
import "./index.css";
import infoIcon from "../../../../../assets/design-revamp-company/company-epr/info-icon.svg";

const QAModalInfo = ({ onClose, onClick }) => {
  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content-base">
        <div className="modal-qa">
          <div className="modal-qa-title">Tip</div>
          <div className="modal-qa-content">
            <div className="modal-qa-texts">
              <p style={{ marginBottom: "23.8px" }}>
                Now we are choosing which accounts contain actual invoices.
                Include accounts by pressing <b>right &gt; </b>and disclude them
                by pressing <b>&lt; left.</b> This will make it much easier -
                also for the future years:{" "}
              </p>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li style={{ marginBottom: "23.8px" }}>
                  <p style={{ textAlign: "center" }}>
                    {" "}
                    <b>Tip:</b> all that it is
                  </p>
                  <p>- VAT accounts</p>
                  <p>- stock regulation</p>
                  <p>- debitor-creditor collecting accounts</p>
                  <p>- bank</p>
                  <p>- loans</p>
                  <p>- debts</p>
                </li>
              </ul>
              <p>
                {" "}
                and other things from the balance sheet are not relevant and can
                be deselected - to the <b>&lt;left.</b>
              </p>
            </div>
            <div className="modal-qa-btn" onClick={onClick}>
              <p>Ok, get started</p>
              <img src={infoIcon} alt="Info Icon" width={25} height={25} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QAModalInfo;
